import { useContext } from "react";
import { AppContext } from "../../../core/contexts/AppContext";
import "./InputTextComponent.scss";

type InputTextComponentPropsType = {
    name: string;
    value: string;
    placeholder?: string;
    onChange?: (name: string, value: string) => void;
    objectValidation?: object;
    error?: any;
    minLength?: number
    maxLength?: number;
    isRequired?: boolean;
    isValitated?: boolean;
    readOnly?: boolean;
}

/**
 * InputTextComponent
 * @param {string} name the name of the input
 * @param {string} value the value of the input
 * @param {string} placeholder the placeholder of the input
 * @param {function} onChange the onChange callback function to call when the input value changes (name, value) => void
 * @param {object} objectValidation indicates the validations for input
 * @param {any} error contains the display error for single input
 * @param {string} type contains the type input
 * @param {boolean} isRequired boolean, true if the field is required
 * @param {boolean} isValitated boolean, true if the field is valited
 * @param {boolean} readOnly boolean, true if the field is readonly
 * @returns {JSX.Element}
 */
const InputTextComponent = ({ name, value, placeholder,
onChange, maxLength, objectValidation = {}, error, isRequired, isValitated, readOnly = false }: InputTextComponentPropsType): JSX.Element => {

    const { appText } = useContext(AppContext);
    const { MESSAGE_VALIDATION_FIELD } = appText;

    const handleChange = (e:any) => {
        if (typeof onChange === "undefined") {
            return;
        }
        const newValue: any = e.currentTarget.value;
        onChange(name, newValue);
    };

    const classNames = {
        "InputTextComponent__label": ["InputTextComponent__label"]
    };

    const classNamesITC = {
        "InputTextComponent": ["InputTextComponent"]
    };

    if (isRequired) {
        classNames["InputTextComponent__label"].push("required");
    }

    if (isValitated){
        classNamesITC["InputTextComponent"].push("form-control"); 
        classNamesITC["InputTextComponent"].push("is-valid"); 
        classNamesITC["InputTextComponent"].push("disabled"); 
    }

    return (
        <div className="InputTextComponent">
            <input
                value={value}
                placeholder={placeholder}
                readOnly={readOnly}
                onChange={(e) => handleChange(e)}
                maxLength={maxLength}
                className={error ? "error" : classNamesITC["InputTextComponent"].join(" ")}
            />
            {error && <div className="Validation__errorMessage">{MESSAGE_VALIDATION_FIELD[error.type.toUpperCase()]}</div>}
        </div>
    );
};

export default InputTextComponent;
